import { useState } from 'react';
import { Button, Typography, Box} from '@mui/material';
import {useTheme} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import URIs from '../../utils/uri';
import useAuth from '../../hooks/useAuth';
import { logout } from '../../api/auth/authAPI';
import { useNotification } from '../../context/NotificationProvider';

const LogoutButton = () => {
    const theme = useTheme();
    const navigate = useNavigate();
    const {setAuth} = useAuth();
    const {showNotification} = useNotification();
    const handleLogout = async() => {
        
        try{
            await logout()
            setAuth({});
            navigate(URIs.LOGIN);
        }catch (error) {
            showNotification(error, 'error')
        } 
    }
    return (
        <Button
            variant="contained"
            sx={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'center',
                alignItems: 'center',
                padding: "14px 0",
                borderRadius: "0",
                width: '100%',
                backgroundColor: theme.palette.background.default,
                color: theme.palette.error.main,
                boxShadow: 'none'
            }}
            onClick={handleLogout}
        >
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center',
                    width: '10%',
                }}
            >
                <ExitToAppIcon
                    sx={{
                        display: 'flex',
                        fontSize: 24,
                        color: theme.palette.error.main,
                        justifyContent: 'center',
                        alignItems: 'center'
                    }}
                />
            </Box>
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'flex-start',
                    width: '70%',
                }}
            >
                <Typography variant='caption2'>
                    خروج از حساب کاربری
                </Typography>
            </Box>
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center',
                    width: '10%',
                }}
            >
                
            </Box>
        </Button>
    );
};

export default LogoutButton;
